module.exports = __webpack_public_path__ + "img/Barcelona.9158bab7.png";